import authService from '@/auth.service'
import Vue from 'vue';
import VueRouter from "vue-router";

import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

// Admin pages
import Overview from 'src/pages/Overview.vue'
import UserProfile from 'src/pages/UserProfile.vue'
import TableList from 'src/pages/TableList.vue'
import Typography from 'src/pages/Typography.vue'
import Icons from 'src/pages/Icons.vue'
import Maps from 'src/pages/Maps.vue'
import Notifications from 'src/pages/Notifications.vue'
import Upgrade from 'src/pages/Upgrade.vue'

//my pages
import LoginView from 'src/pages/Login/LoginView.vue'
import GrnCreate from 'src/pages/Grn/GrnCreate.vue'
import GrnIndex from 'src/pages/Grn/GrnIndex.vue'
import GrnIndexreturn from 'src/pages/Grn/GrnIndexreturn.vue'

import GrnView from 'src/pages/Grn/GrnView.vue'
import GrnUpdate from 'src/pages/Grn/GrnUpdate.vue'
import GrnCreatereturn from 'src/pages/Grn/GrnCreatereturn.vue'
import GrnUpdatedetail from 'src/pages/Grn/GrnUpdatedetail.vue'
import GinCreate from 'src/pages/Gin/GinCreate.vue'
import Createadjust from 'src/pages/Gin/Createadjust.vue'
import GinIndex from 'src/pages/Gin/GinIndex.vue'
import GinIndexcon from 'src/pages/Gin/GinIndexcon.vue'
import GinIndexadjust from 'src/pages/Gin/GinIndexadjust.vue'
import GinView from 'src/pages/Gin/GinView.vue'
import GinViewadjust from 'src/pages/Gin/GinViewadjust.vue'
import GinViewcon from 'src/pages/Gin/GinViewcon.vue'
import CreatesoGin from 'src/pages/Gin/CreatesoGin.vue'
import GinUpdate from 'src/pages/Gin/GinUpdate.vue'
import GinUpdatedetail from 'src/pages/Gin/GinUpdatedetail.vue'
import ApartmentIndex from 'src/pages/Apartment/ApartmentIndex.vue'
import ApartmentView from 'src/pages/Apartment/ApartmentView.vue'
import ApartmentTest from 'src/pages/Apartment/ApartmentTest.vue'
import ApartmentUpdate from 'src/pages/Apartment/ApartmentUpdate.vue'
import TenantUpdate from 'src/pages/Apartment/TenantUpdate.vue'
import ContactUpdate from 'src/pages/Apartment/ContactUpdate.vue'
import OccupantUpdate from 'src/pages/Apartment/OccupantUpdate.vue'

import IssuetrackingIndex from 'src/pages/Issuetracking/IssuetrackingIndex.vue'
import IssuetrackingCreate from 'src/pages/Issuetracking/IssuetrackingCreate.vue'
import IssuetrackingView from 'src/pages/Issuetracking/IssuetrackingView.vue'
import IssuetrackingCreatesplit from 'src/pages/Issuetracking/IssuetrackingCreatesplit.vue'
import CrmIndex from 'src/pages/Crm/CrmIndex.vue'
import CrmCreate from 'src/pages/Crm/CrmCreate.vue'
import CrmView from 'src/pages/Crm/CrmView.vue'
import CrmUpdate from 'src/pages/Crm/CrmUpdate.vue'
import MproductIndex from 'src/pages/Mproduct/MproductIndex.vue'
import MproductView from 'src/pages/Mproduct/MproductView.vue'
import TcreditnotesIndex from 'src/pages/Tcreditnotes/TcreditnotesIndex.vue'
import TcreditnotesView from 'src/pages/Tcreditnotes/TcreditnotesView.vue'
import MproductCreate from 'src/pages/Mproduct/MproductCreate.vue'
import MproductUpdate from 'src/pages/Mproduct/MproductUpdate.vue'
import InventoryIndex from 'src/pages/Inventory/InventoryIndex.vue'
import indexbyProduct from 'src/pages/Inventory/indexbyProduct.vue'
import SquatationIndex from 'src/pages/Squatation/SquatationIndex.vue'
import SquatationPos from 'src/pages/Squatation/SquatationPos.vue'
import SquatationPrint from 'src/pages/Squatation/SquatationPrint.vue'
import SquatationView from 'src/pages/Squatation/SquatationView.vue'
import SquotationUpdate from 'src/pages/Squatation/SquotationUpdate.vue'
import SquatationCreate from 'src/pages/Squatation/SquatationCreate.vue'
import SsalesoderIndex from 'src/pages/Salesorder/SsalesoderIndex.vue'
import SsalesoderIndexcon from 'src/pages/Salesorder/SsalesoderIndexcon.vue'
import SsalesoderCreate from 'src/pages/Salesorder/SsalesoderCreate.vue'
import SsalesoderView from 'src/pages/Salesorder/SsalesoderView.vue'
import SsalesoderViewcon from 'src/pages/Salesorder/SsalesoderViewcon.vue'
import SsalesoderUpdate from 'src/pages/Salesorder/SsalesoderUpdate.vue'
import SinvoiceIndex from 'src/pages/Sinvoice/SinvoiceIndex.vue'
import UsertypeIndex from 'src/pages/User/UsertypeIndex.vue'
import UsertypeCreate from 'src/pages/User/UsertypeCreate.vue'
import SinvoiceView from 'src/pages/Sinvoice/SinvoiceView.vue'
import CreditpartialyInvoice from 'src/pages/Sinvoice/CreditpartialyInvoice.vue'
import CreaterentalInvoice from 'src/pages/Rental/CreaterentalInvoice.vue'
import RentalInvoiceIndex from 'src/pages/Rental/RentalInvoiceIndex.vue'
import SpaymentreceiptsCreate from 'src/pages/Spaymentreceipts/SpaymentreceiptsCreate.vue'
import SpaymentreceiptsIndex from 'src/pages/Spaymentreceipts/SpaymentreceiptsIndex.vue'
import SpaymentreceiptsPdindex from 'src/pages/Spaymentreceipts/SpaymentreceiptsPdindex.vue'
import SpaymentreceiptsView from 'src/pages/Spaymentreceipts/SpaymentreceiptsView.vue'
import SpaymentreceiptsPdview from 'src/pages/Spaymentreceipts/SpaymentreceiptsPdview.vue'
import CreatesoInvoice from 'src/pages/Sinvoice/CreatesoInvoice.vue'
import CreatesoInvoicecon from 'src/pages/Sinvoice/CreatesoInvoicecon.vue'
import McustomerIndex from 'src/pages/Mcustomer/McustomerIndex.vue'
import McustomerCreate from 'src/pages/Mcustomer/McustomerCreate.vue'
import McustomerView from 'src/pages/Mcustomer/McustomerView.vue'
import McustomerUpdate from 'src/pages/Mcustomer/McustomerUpdate.vue'
import MmodelsIndex from 'src/pages/Mmodels/MmodelsIndex.vue'
import MmodelsView from 'src/pages/Mmodels/MmodelsView.vue'
import MmodelsCreate from 'src/pages/Mmodels/MmodelsCreate.vue'
import VinventoryIndex from 'src/pages/Vinventory/VinventoryIndex.vue'
import IdealerassignvehicleIndex from 'src/pages/Idealerassignvehicle/IdealerassignvehicleIndex.vue'
import IdealerassignvehicleCreate from 'src/pages/Idealerassignvehicle/IdealerassignvehicleCreate.vue'
import IdealerassignvehicleRetransfer from 'src/pages/Idealerassignvehicle/IdealerassignvehicleRetransfer.vue'
import IdealerassignvehicleAccept from 'src/pages/Idealerassignvehicle/IdealerassignvehicleAccept.vue'
import SopportunityIndex from 'src/pages/Sopportunity/SopportunityIndex.vue'
import SopportunityCreate from 'src/pages/Sopportunity/SopportunityCreate.vue'
import MenduserIndex from 'src/pages/Menduser/MenduserIndex.vue'
import MenduserView from 'src/pages/Menduser/MenduserView.vue'
import SpfiIndex from 'src/pages/Spfi/SpfiIndex.vue'
import SpfiCreate from 'src/pages/Spfi/SpfiCreate.vue'
import SpfiView from 'src/pages/Spfi/SpfiView.vue'
import SpfiUpdate from 'src/pages/Spfi/SpfiUpdate.vue'
import SvehiclesalesorderIndex from 'src/pages/Svehiclesalesorder/SvehiclesalesorderIndex.vue'
import SvehiclesalesorderCreate from 'src/pages/Svehiclesalesorder/SvehiclesalesorderCreate.vue'
import SvehiclesalesorderView from 'src/pages/Svehiclesalesorder/SvehiclesalesorderView.vue'
import SvehiclesalesorderUpdate from 'src/pages/Svehiclesalesorder/SvehiclesalesorderUpdate.vue'
import SvehiclesalesorderAcceptpo from 'src/pages/Svehiclesalesorder/SvehiclesalesorderAcceptpo.vue'
import SvehicleinvoiceIndex from 'src/pages/Svehicleinvoice/SvehicleinvoiceIndex.vue'
import SvehicleinvoiceCreate from 'src/pages/Svehicleinvoice/SvehicleinvoiceCreate.vue'
import SvehicleinvoiceUpdate from 'src/pages/Svehicleinvoice/SvehicleinvoiceUpdate.vue'
import SvehicleinvoiceView from 'src/pages/Svehicleinvoice/SvehicleinvoiceView.vue'
import SvehiclesalesreceiptIndex from 'src/pages/Svehiclesalesreceipt/SvehiclesalesreceiptIndex.vue'
import SvehiclesalesreceiptView from 'src/pages/Svehiclesalesreceipt/SvehiclesalesreceiptView.vue'
import SvehiclesalesreceiptUpdate from 'src/pages/Svehiclesalesreceipt/SvehiclesalesreceiptUpdate.vue'
import SvehiclesalesreceiptCreate from 'src/pages/Svehiclesalesreceipt/SvehiclesalesreceiptCreate.vue'
import ServicecalenderIndex from 'src/pages/Servicecalender/ServicecalenderIndex.vue'
import RentalIndex from 'src/pages/Rental/RentalIndex.vue'
import RentalGinIndex from 'src/pages/Rental/RentalGinIndex.vue'
import RentalGIn from 'src/pages/Rental/RentalGIn.vue'
import RentalReturnIndex from 'src/pages/Rental/RentalReturnIndex.vue'
import RentalGrnCreate from 'src/pages/Rental/RentalGrnCreate.vue'
import MservicetechnicianIndex from 'src/pages/Mservicetechnician/MservicetechnicianIndex.vue'
import MservicetechnicianCreate from 'src/pages/Mservicetechnician/MservicetechnicianCreate.vue'
import MservicetechnicianUpdate from 'src/pages/Mservicetechnician/MservicetechnicianUpdate.vue'
import MserviceadvisorUpdate from 'src/pages/Mserviceadvisor/MserviceadvisorUpdate.vue'
import MserviceadvisorCreate from 'src/pages/Mserviceadvisor/MserviceadvisorCreate.vue'
import MserviceadvisorIndex from 'src/pages/Mserviceadvisor/MserviceadvisorIndex.vue'
import ServicejobCreate from 'src/pages/Servicejob/ServicejobCreate.vue'
import ServicejobIndex from 'src/pages/Servicejob/ServicejobIndex.vue'
import ServicejobView from 'src/pages/Servicejob/ServicejobView.vue'
import ServicejobUpdate from 'src/pages/Servicejob/ServicejobUpdate.vue'
import ServiceinvoiceCreate from 'src/pages/Serviceinvoice/ServiceinvoiceCreate.vue'
import ServiceinvoiceIndex from 'src/pages/Serviceinvoice/ServiceinvoiceIndex.vue'
import ServiceinvoiceView from 'src/pages/Serviceinvoice/ServiceinvoiceView.vue'
import RentalCalender from 'src/pages/Rental/RentalCalender.vue'
import ServicereceiptCreate from 'src/pages/Servicereceipt/ServicereceiptCreate.vue'
import ServicereceiptIndex from 'src/pages/Servicereceipt/ServicereceiptIndex.vue'
import ServicereceiptView from 'src/pages/Servicereceipt/ServicereceiptView.vue'
import ServicereceiptUpdate from 'src/pages/Servicereceipt/ServicereceiptUpdate.vue'
import VehiclesginIndex from 'src/pages/Vehiclesgin/VehiclesginIndex.vue'
import MaintenanceIndex from 'src/pages/Maintenance/MaintenanceIndex.vue'
import ScheduleService from 'src/pages/sservicejob/ScheduleService.vue'
import UserIndex from 'src/pages/User/UserIndex.vue'
import UserPermission from 'src/pages/User/UserPermission.vue'
import UpdatePassword from 'src/pages/User/UpdatePassword.vue'
import UrlCreate from 'src/pages/User/UrlCreate.vue'
import UrlUpdate from 'src/pages/User/UrlUpdate.vue'
import CpurchasingCreate from 'src/pages/Cpurchasing/CpurchasingCreate.vue'
import CpurchasingIndex from 'src/pages/Cpurchasing/CpurchasingIndex.vue'
import CpurchasingView from 'src/pages/Cpurchasing/CpurchasingView.vue'
import CpurchasingUpdate from 'src/pages/Cpurchasing/CpurchasingUpdate.vue'
import CgrnIndex from 'src/pages/Cgrn/CgrnIndex.vue'
import CgrnCreate from 'src/pages/Cgrn/CgrnCreate.vue'
import CgrnView from 'src/pages/Cgrn/CgrnView.vue'
import MsupplierIndex from 'src/pages/Msupplier/MsupplierIndex.vue'
import MsupplierCreate from 'src/pages/Msupplier/MsupplierCreate.vue'
import MsupplierUpdate from 'src/pages/Msupplier/MsupplierUpdate.vue'
import MsupplierView from 'src/pages/Msupplier/MsupplierView.vue'
import PdfCreate from 'src/pages/Pdf/PdfCreate.vue'
import PdfCreate2 from 'src/pages/Pdf/PdfCreate2.vue'
import PdfCreate3 from 'src/pages/Pdf/PdfCreate3.vue'
import PdfCreate4 from 'src/pages/Pdf/PdfCreate4.vue'
import PdfCreate5 from 'src/pages/Pdf/PdfCreate5.vue'
import PdfCreate6 from 'src/pages/Pdf/PdfCreate6.vue'
import PdfCreate7 from 'src/pages/Pdf/PdfCreate7.vue'
import PdfIndex2 from 'src/pages/Pdf/PdfIndex2.vue'
import PdfIndex from 'src/pages/Pdf/PdfIndex.vue'
import PdfIndextab2 from 'src/pages/Pdf/PdfIndextab2.vue'
import PdfIndextab3 from 'src/pages/Pdf/PdfIndextab3.vue'
import PdfIndextab4 from 'src/pages/Pdf/PdfIndextab4.vue'
import PdfmdpjanIndex from 'src/pages/Pdf/PdfmdpjanIndex.vue'
import PdfmdpjanIndextab2 from 'src/pages/Pdf/PdfmdpjanIndextab2.vue'
import PdfmdpjanIndextab3 from 'src/pages/Pdf/PdfmdpjanIndextab3.vue'
import PdfmdpjanIndextab4 from 'src/pages/Pdf/PdfmdpjanIndextab4.vue'
import PdfmdpjanIndextab5 from 'src/pages/Pdf/PdfmdpjanIndextab5.vue'
import PdfmdpjanIndextab6 from 'src/pages/Pdf/PdfmdpjanIndextab6.vue'
import PdfmdpjanIndextab7 from 'src/pages/Pdf/PdfmdpjanIndextab7.vue'
import PdfmdpjanIndextab8 from 'src/pages/Pdf/PdfmdpjanIndextab8.vue'






import PdfmdpsepIndex from 'src/pages/Pdf/PdfmdpsepIndex.vue'
import PdfmdpsepIndextab2 from 'src/pages/Pdf/PdfmdpsepIndextab2.vue'
import PdfmdpsepIndextab3 from 'src/pages/Pdf/PdfmdpsepIndextab3.vue'
import PdfmdpsepIndextab4 from 'src/pages/Pdf/PdfmdpsepIndextab4.vue'
import PdfmdpsepIndextab5 from 'src/pages/Pdf/PdfmdpsepIndextab5.vue'
import PdfmdpsepIndextab6 from 'src/pages/Pdf/PdfmdpsepIndextab6.vue'
import PdfmdpsepIndextab7 from 'src/pages/Pdf/PdfmdpsepIndextab7.vue'
import PdfmdpsepIndextab8 from 'src/pages/Pdf/PdfmdpsepIndextab8.vue'
import PdfarlIndextab1 from 'src/pages/Pdf/PdfarlIndextab1.vue'
import PdfarlIndextab2 from 'src/pages/Pdf/PdfarlIndextab2.vue'
import PdfarlIndextab3 from 'src/pages/Pdf/PdfarlIndextab3.vue'
import PdfarlIndextab4 from 'src/pages/Pdf/PdfarlIndextab4.vue'
import PdfarlIndextab5 from 'src/pages/Pdf/PdfarlIndextab5.vue'
import PdfarlIndextab6 from 'src/pages/Pdf/PdfarlIndextab6.vue'
import PdfarlIndextab7 from 'src/pages/Pdf/PdfarlIndextab7.vue'
import PdfarlIndextab8 from 'src/pages/Pdf/PdfarlIndextab8.vue'
import PdfarlIndextab9 from 'src/pages/Pdf/PdfarlIndextab9.vue'
import PdfarlIndextab10 from 'src/pages/Pdf/PdfarlIndextab10.vue'
import PdfarlIndextab11 from 'src/pages/Pdf/PdfarlIndextab11.vue'
import PdfarlIndextab12 from 'src/pages/Pdf/PdfarlIndextab12.vue'
import PdfIndexsearch from 'src/pages/Pdf/PdfIndexsearch.vue'
import PdfIndexload from 'src/pages/Pdf/PdfIndexload.vue'
import TimesheetCreate from 'src/pages/Timesheet/TimesheetCreate.vue'
import TimesheetIndex from 'src/pages/Timesheet/TimesheetIndex.vue'
import TrainingIndex from 'src/pages/Training/TrainingIndex.vue'
import TrainingView from 'src/pages/Training/TrainingView.vue'
import TrainingUpdate from 'src/pages/Training/TrainingUpdate.vue'
import RosterCreate from 'src/pages/Roster/RosterCreate.vue'
import RosterIndex from 'src/pages/Roster/RosterIndex.vue'
import RosterActualIndex from 'src/pages/Roster/RosterActualIndex.vue'
import RosterActualView from 'src/pages/Roster/RosterActualView.vue'
import RosterAiActualIndex from 'src/pages/Roster/RosterAiActualIndex.vue'
import RosterAiActualView from 'src/pages/Roster/RosterAiActualView.vue'
import RosterAiIndex from 'src/pages/Roster/RosterAiIndex.vue'
import RosterAiCreate from 'src/pages/Roster/RosterAiCreate.vue'
import RosterAiView from 'src/pages/Roster/RosterAiView.vue'
import RosterPatternIndex from 'src/pages/Roster/RosterPatternIndex.vue'
import RosterPatternCreate from 'src/pages/Roster/RosterPatternCreate.vue'
import FuelCreate from 'src/pages/Fuel/FuelCreate.vue'
import FuelIndex from 'src/pages/Fuel/FuelIndex.vue'
import MsalespeopleIndex from 'src/pages/Msalespeople/MsalespeopleIndex.vue'
import MsalespeopleView from 'src/pages/Msalespeople/MsalespeopleView.vue'
import MsalespeopleCreate from 'src/pages/Msalespeople/MsalespeopleCreate.vue'
import MsalespeopleUpdate from 'src/pages/Msalespeople/MsalespeopleUpdate.vue'
import UservisitReport from 'src/pages/User/UservisitReport.vue'
import UservisitView from 'src/pages/User/UservisitView.vue'


import QuestionsCreate from 'src/pages/Questions/QuestionsCreate.vue'
import QuestionsIndex from 'src/pages/Questions/QuestionsIndex.vue'
import QuestionsView from 'src/pages/Questions/QuestionsView.vue'
import QuestionsUpdate from 'src/pages/Questions/QuestionsUpdate.vue'
import QuestionsAnswer from 'src/pages/Questions/QuestionsAnswer.vue'
import QuestionsAnswersheet from 'src/pages/Questions/QuestionsAnswersheet.vue'


import DproductCreate from 'src/pages/Dproduct/DproductCreate.vue'
import DproductIndex from 'src/pages/Dproduct/DproductIndex.vue'
import DproductView from 'src/pages/Dproduct/DproductView.vue'
import DinventoryIndex from 'src/pages/Dinventory/DinventoryIndex.vue'
import DinventoryBinCard from 'src/pages/Dinventory/DinventoryBinCard.vue'
import DsalesIndex from 'src/pages/Dsales/DsalesIndex.vue'
import DsalesView from 'src/pages/Dsales/DsalesView.vue'
import DsalesCreate from 'src/pages/Dsales/DsalesCreate.vue'
import DginCreate from 'src/pages/Dgin/DginCreate.vue'
import DginIndex from 'src/pages/Dgin/DginIndex.vue'
import DginView from 'src/pages/Dgin/DginView.vue'
import DinvoiceCreate from 'src/pages/Dinvoice/DinvoiceCreate.vue'
import DinvoiceIndex from 'src/pages/Dinvoice/DinvoiceIndex.vue'
import DinvoiceView from 'src/pages/Dinvoice/DinvoiceView.vue'
import DreceiptCreate from 'src/pages/Dreceipt/DreceiptCreate.vue'
import DreceiptIndex from 'src/pages/Dreceipt/DreceiptIndex.vue'
import DreceiptView from 'src/pages/Dreceipt/DreceiptView.vue'
import TicoursesCreate from 'src/pages/Tinternalcourses/TicoursesCreate.vue'
import TicoursesIndex from 'src/pages/Tinternalcourses/TicoursesIndex.vue'
import TicoursesView from 'src/pages/Tinternalcourses/TicoursesView.vue'
import TicoursesDashboard from 'src/pages/Tinternalcourses/TicoursesDashboard.vue'
import TicoursesScheduledIndex from 'src/pages/Tinternalcourses/TicoursesScheduledIndex.vue'
import TicoursesScheduledView from 'src/pages/Tinternalcourses/TicoursesScheduledView.vue'
import TicoursesScheduledUpdate from 'src/pages/Tinternalcourses/TicoursesScheduledUpdate.vue'
import TicoursesSurveyForm from 'src/pages/Tinternalcourses/TicoursesSurveyForm.vue'
import TicoursesAssessment from 'src/pages/Tinternalcourses/TicoursesAssessment.vue'
import TicoursesSurveyQuestions from 'src/pages/Tinternalcourses/TicoursesSurveyQuestions.vue'
import TicoursesScheduledSurveyCreate from 'src/pages/Tinternalcourses/TicoursesScheduledSurveyCreate.vue'
import EmployeeTrainingRequirementIndex from 'src/pages/Tinternalcourses/EmployeeTrainingRequirementIndex.vue'
import JobCreate from 'src/pages/Job/JobCreate.vue'
import JobDescriptionCreate from 'src/pages/Job/JobDescriptionCreate.vue'
import JobIndex from 'src/pages/Job/JobIndex.vue'
import JobDescriptionIndex from 'src/pages/Job/JobDescriptionIndex.vue'
import JobDescriptionUpdate from 'src/pages/Job/JobDescriptionUpdate.vue'
import JobUpdate from 'src/pages/Job/JobUpdate.vue'



import DocumentIndex from 'src/pages/Document/DocumentIndex.vue'
import DocumentCreate from 'src/pages/Document/DocumentCreate.vue'
import DocumentView from 'src/pages/Document/DocumentView.vue'
import DocumentUpdate from 'src/pages/Document/DocumentUpdate.vue'
import DocumentBulkCreate from 'src/pages/Document/DocumentBulkCreate.vue'





import AssetsIndex from 'src/Cmms/Assets/AssetsIndex.vue'

import AssetsScadaIndex from 'src/Cmms/Assets/AssetsScadaIndex.vue'
import AssetsScadaView from 'src/Cmms/Assets/AssetsScadaView.vue'
import AssetsView from 'src/Cmms/Assets/AssetsView.vue'
import AssetsCreate from 'src/Cmms/Assets/AssetsCreate.vue'
import AssetsUpdate from 'src/Cmms/Assets/AssetsUpdate.vue'
import AssetsTransfer from 'src/Cmms/Assets/AssetsTransfer.vue'
import CmmscrmIndex from 'src/Cmms/Crm/CrmIndex.vue'
import CmmscrmView from 'src/Cmms/Crm/CrmView.vue'
import CmmscrmCreate from 'src/Cmms/Crm/CrmCreate.vue'
import CmmscrmUpdate from 'src/Cmms/Crm/CrmUpdate.vue'
import CmmsinventoryIndex from 'src/Cmms/Inventory/InventoryIndex.vue'
import CmmsinventoryIndexbyproduct from 'src/Cmms/Inventory/indexbyProduct.vue'
import CmmsservicecalenderIndex from 'src/Cmms/Service/ServicecalenderIndex.vue'
import CmmsservicejobIndex from 'src/Cmms/Service/ServicejobIndex.vue'
import CmmserviceprevenitvejobIndex from 'src/Cmms/Service/ServiceprevenitvejobIndex.vue'
import CmmsservicejobCreate from 'src/Cmms/Service/ServicejobCreate.vue'
import CmmsrepairjobCreate from 'src/Cmms/Service/RepairjobCreate.vue'
import CmmsservicejobUpdate from 'src/Cmms/Service/ServicejobUpdate.vue'
import CmmsservicejobView from 'src/Cmms/Service/ServicejobView.vue'
import CmmsginCreate from 'src/Cmms/Gin/GinCreate.vue'
import CmmsginIndex from 'src/Cmms/Gin/GinIndex.vue'
import CmmsginView from 'src/Cmms/Gin/GinView.vue'
import CmmsginUpdate from 'src/Cmms/Gin/GinUpdate.vue'


import ChatIndex from 'src/pages/Chat/ChatIndex.vue'


import LogbookCreate from 'src/pages/Logbook/LogbookCreate.vue'
import LogbookIndex from 'src/pages/Logbook/LogbookIndex.vue'
import LogbookView from 'src/pages/Logbook/LogbookView.vue'
import ProjectCreate from 'src/pages/ProjectManagement/ProjectCreate.vue'
import ProjectDashboard from 'src/pages/ProjectManagement/ProjectDashboard.vue'
import ProjectIndex from 'src/pages/ProjectManagement/ProjectIndex.vue'
import ProjectVisitCreate from 'src/pages/ProjectManagement/ProjectVisitCreate.vue'
import ProjectVisitIndex from 'src/pages/ProjectManagement/ProjectVisitIndex.vue'
import ProjectVisitView from 'src/pages/ProjectManagement/ProjectVisitView.vue'
import ProjectView from 'src/pages/ProjectManagement/ProjectView.vue'

import MicrosoftExcelUpload from 'src/pages/Microsoft/MicrosoftExcelUpload.vue'
import MicrosoftCallback from 'src/pages/Microsoft/MicrosoftCallback.vue'


import SettingIndex from 'src/pages/Setting/SettingIndex.vue'
import SettingCreate from 'src/pages/Setting/SettingCreate.vue'
import SettingUpdate from 'src/pages/Setting/SettingUpdate.vue'
import SettingUpdateall from 'src/pages/Setting/SettingUpdateall.vue'
import SettingDefault from 'src/pages/Setting/SettingDefault.vue'
import UserCreate from 'src/pages/User/UserCreate.vue'
import UsertypePermission from 'src/pages/User/UsertypePermission.vue'
// import PdfIndextab4 from '../pages/Pdf/PdfIndextab4.vue';

Vue.use(VueRouter);


 const routes  = [

  {
    path: '/',
    component: DashboardLayout,
    name: 'DashboardLayout',
    redirect: '/admin/overview'
  },
 {
    path: '/msalespeople/view',
    name: 'MsalespeopleView',
    component: MsalespeopleView
  },

    {
      path: '/logbook/index',
      name: 'LogbookIndex',
      component: LogbookIndex
    },

    {
      path: '/logbook/create',
      name: 'LogbookCreate',
      component: LogbookCreate
    },

    {
      path: '/logbook/view',
      name: 'LogbookView',
      component: LogbookView
    },
  {
    path: '/dproduct/index',
    name: 'DproductIndex',
    component: DproductIndex
  },
  {
    path: '/dproduct/view',
    name: 'DproductView',
    component: DproductView
  },
  {
    path: '/dproduct/create',
    name: 'DproductCreate',
    component: DproductCreate
  },
  {
    path: '/dinventory/index',
    name: 'DinventoryIndex',
    component: DinventoryIndex
  },
  {
    path: '/dinventory/bin-card',
    name: 'DinventoryBinCard',
    component: DinventoryBinCard
  },
  {
    path: '/dsales/create',
    name: 'DsalesCreate',
    component: DsalesCreate
  },
  {
    path: '/dsales/index',
    name: 'DsalesIndex',
    component: DsalesIndex
  },
  {
    path: '/dsales/view',
    name: 'DsalesView',
    component: DsalesView
  },
  {
    path: '/dgin/create',
    name: 'DginCreate',
    component: DginCreate
  },
  {
    path: '/dgin/index',
    name: 'DginIndex',
    component: DginIndex
  },
  {
    path: '/dgin/view',
    name: 'DginView',
    component: DginView
  },
  {
    path: '/dinvoice/create',
    name: 'DinvoiceCreate',
    component: DinvoiceCreate
  },
  {
    path: '/dinvoice/index',
    name: 'DinvoiceIndex',
    component: DinvoiceIndex
  },
  {
    path: '/dinvoice/view',
    name: 'DinvoiceView',
    component: DinvoiceView
  },
  {
    path: '/dreceipt/create',
    name: 'DreceiptCreate',
    component: DreceiptCreate
  },
  {
    path: '/dreceipt/index',
    name: 'DreceiptIndex',
    component: DreceiptIndex
  },
  {
    path: '/dreceipt/view',
    name: 'DreceiptView',
    component: DreceiptView
  },
  {
    path: '/tinternalcourses/create',
    name: 'TicoursesCreate',
    component: TicoursesCreate
  },
  {
    path: '/tinternalcourses/index',
    name: 'TicoursesIndex',
    component: TicoursesIndex
  },
  {
    path: '/tinternalcourses/view',
    name: 'TicoursesView',
    component: TicoursesView
  },
  {
    path: '/tinternalcourses/dashboard',
    name: 'TicoursesDashboard',
    component: TicoursesDashboard
  },
  {
    path: '/tinternalcourses/scheduled',
    name: 'TicoursesScheduledIndex',
    component: TicoursesScheduledIndex
  },
  {
    path: '/tinternalcourses/scheduled/view',
    name: 'TicoursesScheduledView',
    component: TicoursesScheduledView
  },
  {
    path: '/tinternalcourses/scheduled/update',
    name: 'TicoursesScheduledUpdate',
    component: TicoursesScheduledUpdate
  },
  {
    path: '/tinternalcourses/scheduled/survey',
    name: 'TicoursesSurveyForm',
    component: TicoursesSurveyForm
  },
  {
    path: '/tinternalcourses/scheduled/assessment',
    name: 'TicoursesAssessment',
    component: TicoursesAssessment
  },
  {
    path: '/tinternalcourses/survey-questions',
    name: 'TicoursesSurveyQuestions',
    component: TicoursesSurveyQuestions
  },
  {
    path: '/tinternalcourses/scheduled/create-survey',
    name: 'TicoursesScheduledSurveyCreate',
    component: TicoursesScheduledSurveyCreate
  },
  {
    path: '/tinternalcourses/employee-training-requirement',
    name: 'EmployeeTrainingRequirementIndex',
    component: EmployeeTrainingRequirementIndex
  },


  {
    path: '/document/index',
    name: 'DocumentIndex',
    component: DocumentIndex
  },
  {
    path: '/document/create',
    name: 'DocumentCreate',
    component: DocumentCreate
  },
  {
    path: '/document/view',
    name: 'DocumentView',
    component: DocumentView
  },
  {
    path: '/document/update',
    name: 'DocumentUpdate',
    component: DocumentUpdate
  },
  {
    path: '/document/bulk-create',
    name: 'DocumentBulkCreate',
    component: DocumentBulkCreate
  },

  {
    path: '/job/update',
    name: 'JobUpdate',
    component: JobUpdate
  },
  {
    path: '/job/desupdate',
    name: 'JobDescriptionUpdate',
    component: JobDescriptionUpdate
  },
  {
    path: '/job/desindex',
    name: 'JobDescriptionIndex',
    component: JobDescriptionIndex
  },
  {
    path: '/job/index',
    name: 'JobIndex',
    component: JobIndex
  },
  {
    path: '/job/create',
    name: 'JobCreate',
    component: JobCreate
  },
  {
    path: '/job/descreate',
    name: 'JobDescriptionCreate',
    component: JobDescriptionCreate
  },
    {
      path: '/projectmanagement/dashboard',
      name: 'ProjectDashboard',
      component: ProjectDashboard
    },
    {
      path: '/projectmanagement/index',
      name: 'ProjectIndex',
      component: ProjectIndex
    },
    {
      path: '/projectmanagement/create',
      name: 'ProjectCreate',
      component: ProjectCreate
    },
    {
      path: '/projectmanagement/visitindex',
      name: 'ProjectVisitIndex',
      component: ProjectVisitIndex
    },
    {
      path: '/projectmanagement/visitcreate',
      name: 'ProjectVisitCreate',
      component: ProjectVisitCreate
    },
    {
      path: '/projectmanagement/visitview',
      name: 'ProjectVisitView',
      component: ProjectVisitView
    },
    {
      path: '/projectmanagement/view',
      name: 'ProjectView',
      component: ProjectView
    },
   
   
   
    
    
    
    {
      path: '/microsoft/excel-upload',
      name: 'MicrosoftExcelUpload',
      component: MicrosoftExcelUpload,
      // meta: {
      //   requiredPermission: '/microsoft/excel-upload',
      // },
    },
    {
      path: '/microsoft/callback',
      name: 'MicrosoftCallback',
      component: MicrosoftCallback
    },


  {
    path: '/questions/create',
    name: 'QuestionsCreate',
    component: QuestionsCreate
  },
  {
    path: '/questions/index',
    name: 'QuestionsIndex',
    component: QuestionsIndex
  },
  {
    path: '/questions/view',
    name: 'QuestionsView',
    component: QuestionsView
  },
  {
    path: '/questions/update',
    name: 'QuestionsUpdate',
    component: QuestionsUpdate
  },
  {
    path: '/questions/answer',
    name: 'QuestionsAnswer',
    component: QuestionsAnswer
  },
  {
    path: '/questions/answersheet',
    name: 'QuestionsAnswersheet',
    component: QuestionsAnswersheet
  },


 {
    path: '/cmmsservicejob/view',
    name: 'CmmsservicejobView',
    component: CmmsservicejobView
  },
 {
    path: '/cmmsservicejob/update',
    name: 'CmmsservicejobUpdate',
    component: CmmsservicejobUpdate
  },
 {
    path: '/cmmsservicejob/create',
    name: 'CmmsservicejobCreate',
    component: CmmsservicejobCreate
  },
 {
    path: '/cmmsservicejob/repairjobcreate',
    name: 'CmmsrepairjobCreate',
    component: CmmsrepairjobCreate
  },
 {
    path: '/cmmsservicejob/index',
    name: 'CmmsservicejobIndex',
    component: CmmsservicejobIndex
  },
 {
    path: '/cmmserviceprevenitvejob/index',
    name: 'CmmserviceprevenitvejobIndex',
    component: CmmserviceprevenitvejobIndex
  },
 {
    path: '/cmmsservicecalender/index',
    name: 'CmmsservicecalenderIndex',
    component: CmmsservicecalenderIndex
  },
 {
    path: '/cmmsinventory/indexbyproduct',
    name: 'CmmsinventoryIndexbyproduct',
    component: CmmsinventoryIndexbyproduct
  },
 {
    path: '/cmmsinventory/index',
    name: 'CmmsinventoryIndex',
    component: CmmsinventoryIndex
  },
 {
    path: '/cmmscrm/index',
    name: 'CmmscrmIndex',
    component: CmmscrmIndex
  },
 {
    path: '/cmmscrm/view',
    name: 'CmmscrmView',
    component: CmmscrmView
  },
 {
    path: '/cmmscrm/create',
    name: 'CmmscrmCreate',
    component: CmmscrmCreate
  },
 {
    path: '/cmmscrm/update',
    name: 'CmmscrmUpdate',
    component: CmmscrmUpdate
  },
 {
    path: '/cmmsassets/index',
    name: 'AssetsIndex',
    component: AssetsIndex
  },
  {
    path: '/cmmsassets/excel-index',
    name: 'AssetsScadaIndex',
    component: AssetsScadaIndex
  },
  {
    path: '/cmmsassets/excel-view',
    name: 'AssetsScadaView',
    component: AssetsScadaView
  },
 {
    path: '/cmmsassets/view',
    name: 'AssetsView',
    component: AssetsView
  },
 {
    path: '/cmmsassets/create',
    name: 'AssetsCreate',
    component: AssetsCreate
  },
 {
    path: '/cmmsassets/update',
    name: 'AssetsUpdate',
    component: AssetsUpdate
  },
 {
    path: '/cmmsassets/transfer',
    name: 'AssetsTransfer',
    component: AssetsTransfer
  },
 {
    path: '/cmmsgin/create',
    name: 'CmmsginCreate',
    component: CmmsginCreate
  },
 {
    path: '/cmmsgin/index',
    name: 'CmmsginIndex',
    component: CmmsginIndex
  },
 {
    path: '/cmmsgin/view',
    name: 'CmmsginView',
    component: CmmsginView
  },
 {
    path: '/cmmsgin/update',
    name: 'CmmsginUpdate',
    component: CmmsginUpdate
  },


  {
    path: '/user/visitreport',
    name: 'UservisitReport',
    component: UservisitReport
  },
  {
    path: '/user/visitview',
    name: 'UservisitView',
    component: UservisitView
  },
  {
    path: '/chat/index',
    name: 'ChatIndex',
    component: ChatIndex
  },


   {
    path: '/msalespeople/create',
    name: 'MsalespeopleCreate',
    component: MsalespeopleCreate
  },
   {
    path: '/msalespeople/update',
    name: 'MsalespeopleUpdate',
    component: MsalespeopleUpdate
  },


  {
    path: '/msalespeople/index',
    name: 'MsalespeopleIndex',
    component: MsalespeopleIndex
  },
  {
    path: '/timesheet/create',
    name: 'TimesheetCreate',
    component: TimesheetCreate
  },
  {
    path: '/timesheet/index',
    name: 'TimesheetIndex',
    component: TimesheetIndex
  },
  {
    path: '/training/index',
    name: 'TrainingIndex',
    component: TrainingIndex
  },
  {
    path: '/training/view',
    name: 'TrainingView',
    component: TrainingView
  },
  {
    path: '/training/update',
    name: 'TrainingUpdate',
    component: TrainingUpdate
  },
  {
    path: '/roster/create',
    name: 'RosterCreate',
    component: RosterCreate
  },
  {
    path: '/roster/view',
    name: 'RosterView',
    component: RosterCreate
  },
  {
    path: '/roster/actual/index',
    name: 'RosterActualIndex',
    component: RosterActualIndex
  },
  {
    path: '/roster/actual/view',
    name: 'RosterActualView',
    component: RosterActualView
  },
  {
    path: '/roster/ai/index',
    name: 'RosterAiIndex',
    component: RosterAiIndex
  },
  {
    path: '/roster/ai/create',
    name: 'RosterAiCreate',
    component: RosterAiCreate
  },
  {
    path: '/roster/ai/view',
    name: 'RosterAiView',
    component: RosterAiView
  },
  {
    path: '/roster/ai/actual/index',
    name: 'RosterAiActualIndex',
    component: RosterAiActualIndex
  },
  {
    path: '/roster/ai/actual/view',
    name: 'RosterAiActualView',
    component: RosterAiActualView
  },
  {
    path: '/roster/index',
    name: 'RosterIndex',
    component: RosterIndex
  },
  {
    path: '/roster/pattern/index',
    name: 'RosterPatternIndex',
    component: RosterPatternIndex
  },
  {
    path: '/roster/pattern/create',
    name: 'RosterPatternCreate',
    component: RosterPatternCreate
  },
   {
    path: '/fuel/index',
    name: 'FuelIndex',
    component: FuelIndex
  },
  {
    path: '/fuel/create',
    name: 'FuelCreate',
    component: FuelCreate
  },
  {
    path: '/spfi/update',
    name: 'SpfiUpdate',
    component: SpfiUpdate
  },
  {
    path: '/usertype/index',
    name: 'UsertypeIndex',
    component: UsertypeIndex
  },
  {
    path: '/cpurchasing/create',
    name: 'CpurchasingCreate',
    component: CpurchasingCreate
  },
  {
    path: '/cpurchasing/index',
    name: 'CpurchasingIndex',
    component: CpurchasingIndex
  },
  {
    path: '/cpurchasing/view',
    name: 'CpurchasingView',
    component: CpurchasingView
  },
  {
    path: '/cpurchasing/update',
    name: 'CpurchasingUpdate',
    component: CpurchasingUpdate
  },
  {
    path: '/cgrn/index',
    name: 'CgrnIndex',
    component: CgrnIndex
  },
  {
    path: '/cgrn/create',
    name: 'CgrnCreate',
    component: CgrnCreate
  },
  {
    path: '/cgrn/view',
    name: 'CgrnView',
    component: CgrnView
  },
  {
    path: '/msupplier/index',
    name: 'MsupplierIndex',
    component: MsupplierIndex
  },
  {
    path: '/msupplier/create',
    name: 'MsupplierCreate',
    component: MsupplierCreate
  },
  {
    path: '/msupplier/update',
    name: 'MsupplierUpdate',
    component: MsupplierUpdate
  },
  {
    path: '/msupplier/view',
    name: 'MsupplierView',
    component: MsupplierView
  },
  {
    path: '/pdf/create',
    name: 'PdfCreate',
    component: PdfCreate
  },
  {
    path: '/pdf/create2',
    name: 'PdfCreate2',
    component: PdfCreate2
  },
  {
    path: '/pdf/create3',
    name: 'PdfCreate3',
    component: PdfCreate3
  },
  {
    path: '/pdf/create4',
    name: 'PdfCreate4',
    component: PdfCreate4
  },
  {
    path: '/pdf/create5',
    name: 'PdfCreate5',
    component: PdfCreate5
  },
  {
    path: '/pdf/create6',
    name: 'PdfCreate6',
    component: PdfCreate6
  },
  {
    path: '/pdf/create7',
    name: 'PdfCreate7',
    component: PdfCreate7
  },
  {
    path: '/pdf/index2',
    name: 'PdfIndex2',
    component: PdfIndex2
  },
  {
    path: '/pdf/index',
    name: 'PdfIndex',
    component: PdfIndex
  },
  {
    path: '/pdf/indextab2',
    name: 'PdfIndextab2',
    component: PdfIndextab2
  },
  {
    path: '/pdf/indextab3',
    name: 'PdfIndextab3',
    component: PdfIndextab3
  },
  {
    path: '/pdf/indextab4',
    name: 'PdfIndextab4',
    component: PdfIndextab4
  },
  {
    path: '/Pdfmdpjan/index',
    name: 'PdfmdpjanIndex',
    component: PdfmdpjanIndex
  },
  {
    path: '/Pdfmdpjan/indextab2',
    name: 'PdfmdpjanIndextab2',
    component: PdfmdpjanIndextab2
  },
  {
    path: '/Pdfmdpjan/indextab3',
    name: 'PdfmdpjanIndextab3',
    component: PdfmdpjanIndextab3
  },
  {
    path: '/Pdfmdpjan/indextab4',
    name: 'PdfmdpjanIndextab4',
    component: PdfmdpjanIndextab4
  },
  {
    path: '/Pdfmdpjan/indextab5',
    name: 'PdfmdpjanIndextab5',
    component: PdfmdpjanIndextab5
  },
  {
    path: '/Pdfmdpjan/indextab6',
    name: 'PdfmdpjanIndextab6',
    component: PdfmdpjanIndextab6
  },

  {
    path: '/Pdfmdpjan/indextab7',
    name: 'PdfmdpjanIndextab7',
    component: PdfmdpjanIndextab7
  },
  {
    path: '/Pdfmdpjan/indextab8',
    name: 'PdfmdpjanIndextab8',
    component: PdfmdpjanIndextab8
  },

  {
    path: '/Pdfmdpsep/index',
    name: 'PdfmdpsepIndex',
    component: PdfmdpsepIndex
  },
  {
    path: '/Pdfmdpsep/indextab2',
    name: 'PdfmdpsepIndextab2',
    component: PdfmdpsepIndextab2
  },
  {
    path: '/Pdfmdpsep/indextab3',
    name: 'PdfmdpsepIndextab3',
    component: PdfmdpsepIndextab3
  },
  {
    path: '/Pdfmdpsep/indextab4',
    name: 'PdfmdpsepIndextab4',
    component: PdfmdpsepIndextab4
  },
  {
    path: '/Pdfmdpsep/indextab5',
    name: 'PdfmdpsepIndextab5',
    component: PdfmdpsepIndextab5
  },
  {
    path: '/Pdfmdpsep/indextab6',
    name: 'PdfmdpsepIndextab6',
    component: PdfmdpsepIndextab6
  },

  {
    path: '/Pdfmdpsep/indextab7',
    name: 'PdfmdpsepIndextab7',
    component: PdfmdpsepIndextab7
  },
  {
    path: '/Pdfmdpsep/indextab8',
    name: 'PdfmdpsepIndextab8',
    component: PdfmdpsepIndextab8
  },

  {
    path: '/Pdfarl/indextab1',
    name: 'PdfarlIndextab1',
    component: PdfarlIndextab1
  },
  {
    path: '/Pdfarl/indextab2',
    name: 'PdfarlIndextab2',
    component: PdfarlIndextab2
  },

   {
    path: '/Pdfarl/indextab3',
    name: 'PdfarlIndextab3',
    component: PdfarlIndextab3
  },
   {
    path: '/Pdfarl/indextab4',
    name: 'PdfarlIndextab4',
    component: PdfarlIndextab4
  },
   {
    path: '/Pdfarl/indextab5',
    name: 'PdfarlIndextab5',
    component: PdfarlIndextab5
  },
   {
    path: '/Pdfarl/indextab6',
    name: 'PdfarlIndextab6',
    component: PdfarlIndextab6
  },
   {
    path: '/Pdfarl/indextab7',
    name: 'PdfarlIndextab7',
    component: PdfarlIndextab7
  },
   {
    path: '/Pdfarl/indextab8',
    name: 'PdfarlIndextab8',
    component: PdfarlIndextab8
  },
   {
    path: '/Pdfarl/indextab9',
    name: 'PdfarlIndextab9',
    component: PdfarlIndextab9
  },
   {
    path: '/Pdfarl/indextab10',
    name: 'PdfarlIndextab10',
    component: PdfarlIndextab10
  },

    {
    path: '/Pdfarl/indextab11',
    name: 'PdfarlIndextab11',
    component: PdfarlIndextab11
  },

  {
   path: '/Pdfarl/indextab12',
   name: 'PdfarlIndextab12',
   component: PdfarlIndextab12
 },
  {
   path: '/Pdf/indexsearch',
   name: 'PdfIndexsearch',
   component: PdfIndexsearch
 },
  {
   path: '/Pdf/indexload',
   name: 'PdfIndexload',
   component: PdfIndexload
 },
  {
    path: '/usertype/create',
    name: 'UsertypeCreate',
    component: UsertypeCreate
  },
  {
    path: '/usertype/permission',
    name: 'UsertypePermission',
    component: UsertypePermission
  },
  {
    path: '/user/index',
    name: 'UserIndex',
    component: UserIndex
  },
  {
    path: '/setting/index',
    name: 'SettingIndex',
    component: SettingIndex
  },
  {
    path: '/setting/index',
    name: 'SettingIndex',
    component: SettingIndex
  },
  {
    path: '/setting/updateall',
    name: 'SettingUpdateall',
    component: SettingUpdateall
  },
  {
    path: '/setting/default',
    name: 'SettingDefault',
    component: SettingDefault
  },
  {
    path: '/setting/update',
    name: 'SettingUpdate',
    component: SettingUpdate
  },
  {
    path: '/user/permission',
    name: 'UserPermission',
    component: UserPermission
  },
  {
    path: '/setting/create',
    name: 'SettingCreate',
    component: SettingCreate
  },

  {
    path: '/user/updatepassword',
    name: 'UpdatePassword',
    component: UpdatePassword
  },
  {
    path: '/user/create',
    name: 'UserCreate',
    component: UserCreate
  },
  {
    path: '/url/create',
    name: 'UrlCreate',
    component: UrlCreate
  },
  {
    path: '/url/update',
    name: 'UrlUpdate',
    component: UrlUpdate
  },
  {
    path: '/vehiclesgin/index',
    name: 'VehiclesginIndex',
    component: VehiclesginIndex,

  },
  {
    path: '/servicereceipt/update',
    name: 'ServicereceiptUpdate',
    component: ServicereceiptUpdate
  },
  {
    path: '/servicereceipt/view',
    name: 'ServicereceiptView',
    component: ServicereceiptView
  },
  {
    path: '/servicereceipt/index',
    name: 'ServicereceiptIndex',
    component: ServicereceiptIndex
  },
  {
    path: '/servicereceipt/create',
    name: 'ServicereceiptCreate',
    component: ServicereceiptCreate
  },
  {
    path: '/serviceinvoice/view',
    name: 'ServiceinvoiceView',
    component: ServiceinvoiceView
  },
  {
    path: '/serviceinvoice/index',
    name: 'ServiceinvoiceIndex',
    component: ServiceinvoiceIndex
  },
  {
    path: '/rental/calnder',
    name: 'RentalCalender',
    component: RentalCalender
  },
  {
    path: '/rental/invoice/index',
    name: 'RentalInvoiceIndex',
    component: RentalInvoiceIndex
  },
  {
    path: '/serviceinvoice/index1',
    redirect: '/rental/calnder'
  },
  {
    path: '/serviceinvoice/create',
    name: 'ServiceinvoiceCreate',
    component: ServiceinvoiceCreate
  },
  {
    path: '/servicejob/update',
    name: 'ServicejobUpdate',
    component: ServicejobUpdate
  },
  {
    path: '/servicejob/view',
    name: 'ServicejobView',
    component: ServicejobView
  },
  {
    path: '/servicejob/create',
    name: 'ServicejobCreate',
    component: ServicejobCreate
  },
  {
    path: '/rental/gin',
    name: 'RentalGIn',
    component: RentalGIn
  },
  {
    path: '/rental/gin/index',
    name: 'RentalGinIndex',
    component: RentalGinIndex
  },
  {
    path: '/rental/return/index',
    name: 'RentalReturnIndex',
    component: RentalReturnIndex
  },
  {
    path: '/rental/grn/create',
    name: 'RentalGrnCreate',
    component: RentalGrnCreate
  },
  {
    path: '/servicejob/index1',
    redirect: '/rental/gin'
  },
  {
    path: '/servicejob/index',
    name: 'ServicejobIndex',
    component: ServicejobIndex
  },
  {
    path: '/mserviceadvisor/update',
    name: 'MserviceadvisorUpdate',
    component: MserviceadvisorUpdate
  },
  {
    path: '/mserviceadvisor/create',
    name: 'MserviceadvisorCreate',
    component: MserviceadvisorCreate
  },
  {
    path: '/mserviceadvisor/index',
    name: 'MserviceadvisorIndex',
    component: MserviceadvisorIndex
  },
  {
    path: '/mservicetechnician/update',
    name: 'MservicetechnicianUpdate',
    component: MservicetechnicianUpdate
  },
  {
    path: '/mservicetechnician/create',
    name: 'MservicetechnicianCreate',
    component: MservicetechnicianCreate
  },
  {
    path: '/mservicetechnician/index',
    name: 'MservicetechnicianIndex',
    component: MservicetechnicianIndex
  },
  {
    path: '/rental/index',
    name: 'RentalIndex',
    component: RentalIndex
  },
  {
    path: '/servicecalender/index1',
    redirect: '/rental/index'
  },
  {
    path: '/servicecalender/index',
    name: 'ServicecalenderIndex',
    component: ServicecalenderIndex
  },
  {
    path: '/svehiclesalesreceipt/update',
    name: 'SvehiclesalesreceiptUpdate',
    component: SvehiclesalesreceiptUpdate
  },
  {
    path: '/svehiclesalesreceipt/view',
    name: 'SvehiclesalesreceiptView',
    component: SvehiclesalesreceiptView
  },
  {
    path: '/svehiclesalesreceipt/index',
    name: 'SvehiclesalesreceiptIndex',
    component: SvehiclesalesreceiptIndex
  },
  {
    path: '/svehiclesalesreceipt/create',
    name: 'SvehiclesalesreceiptCreate',
    component: SvehiclesalesreceiptCreate
  },
  {
    path: '/Svehicleinvoice/view',
    name: 'SvehicleinvoiceView',
    component: SvehicleinvoiceView
  },
  {
    path: '/Svehicleinvoice/update',
    name: 'SvehicleinvoiceUpdate',
    component: SvehicleinvoiceUpdate
  },
  {
    path: '/Svehicleinvoice/create',
    name: 'SvehicleinvoiceCreate',
    component: SvehicleinvoiceCreate
  },
  {
    path: '/Svehicleinvoice/Index',
    name: 'SvehicleinvoiceIndex',
    component: SvehicleinvoiceIndex
  },
  {
    path: '/svehiclesalesorder/acceptpo',
    name: 'SvehiclesalesorderAcceptpo',
    component: SvehiclesalesorderAcceptpo
  },
  {
    path: '/svehiclesalesorder/update',
    name: 'SvehiclesalesorderUpdate',
    component: SvehiclesalesorderUpdate
  },
  {
    path: '/svehiclesalesorder/view',
    name: 'SvehiclesalesorderView',
    component: SvehiclesalesorderView
  },
  {
    path: '/svehiclesalesorder/index',
    name: 'SvehiclesalesorderIndex',
    component: SvehiclesalesorderIndex
  },
  {
    path: '/svehiclesalesorder/create',
    name: 'SvehiclesalesorderCreate',
    component: SvehiclesalesorderCreate
  },
  {
    path: '/spfi/view',
    name: 'SpfiView',
    component: SpfiView
  },
  {
    path: '/spfi/create',
    name: 'SpfiCreate',
    component: SpfiCreate
  },
  {
    path: '/spfi/index',
    name: 'SpfiIndex',
    component: SpfiIndex
  },
  {
    path: '/menduser/view',
    name: 'MenduserView',
    component: MenduserView
  },
  {
    path: '/menduser/index',
    name: 'MenduserIndex',
    component: MenduserIndex
  },
  {
    path: '/sopportunity/index',
    name: 'SopportunityIndex',
    component: SopportunityIndex
  },
  {
    path: '/sopportunity/create',
    name: 'SopportunityCreate',
    component: SopportunityCreate
  },
  {
    path: '/idealerassignvehicle/retransfer',
    name: 'IdealerassignvehicleRetransfer',
    component: IdealerassignvehicleRetransfer
  },
  {
    path: '/idealerassignvehicle/accept',
    name: 'IdealerassignvehicleAccept',
    component: IdealerassignvehicleAccept
  },
  {
    path: '/idealerassignvehicle/index',
    name: 'IdealerassignvehicleIndex',
    component: IdealerassignvehicleIndex
  },
  {
    path: '/idealerassignvehicle/create',
    name: 'IdealerassignvehicleCreate',
    component: IdealerassignvehicleCreate
  },
  {
    path: '/vinventory/index',
    name: 'VinventoryIndex',
    component: VinventoryIndex
  },
  {
    path: '/mproduct/create',
    name: 'MproductCreate',
    component: MproductCreate
  },
  {
    path: '/mmodels/index',
    name: 'MmodelsIndex',
    component: MmodelsIndex
  },
  {
    path: '/mmodels/create',
    name: 'MmodelsCreate',
    component: MmodelsCreate
  },
  {
    path: '/mmodels/view',
    name: 'MmodelsView',
    component: MmodelsView
  },
  {
    path: '/tcreditnotes/index',
    name: 'TcreditnotesIndex',
    component: TcreditnotesIndex
  },
  {
    path: '/tcreditnotes/view',
    name: 'TcreditnotesView',
    component: TcreditnotesView
  },
  {
    path: '/spaymentreceipts/view',
    name: 'SpaymentreceiptsView',
    component: SpaymentreceiptsView
  },
  {
    path: '/spaymentreceipts/pdview',
    name: 'SpaymentreceiptsPdview',
    component: SpaymentreceiptsPdview
  },
  {
    path: '/spaymentreceipts/create',
    name: 'SpaymentreceiptsCreate',
    component: SpaymentreceiptsCreate
  },
  {
    path: '/spaymentreceipts/index',
    name: 'SpaymentreceiptsIndex',
    component: SpaymentreceiptsIndex
  },
  {
    path: '/spaymentreceipts/pdindex',
    name: 'SpaymentreceiptsPdindex',
    component: SpaymentreceiptsPdindex
  },
  {
    path: '/sinvoice/index',
    name: 'SinvoiceIndex',
    component: SinvoiceIndex
  },
  {
    path: '/sinvoice/view',
    name: 'SinvoiceView',
    component: SinvoiceView
  },
  {
    path: '/sinvoice/createsoinvoice',
    name: 'CreatesoInvoice',
    component: CreatesoInvoice
  },
  {
    path: '/sinvoice/creditpartialy',
    name: 'CreditpartialyInvoice',
    component: CreditpartialyInvoice
  },
  {
    path: '/sinvoice/createsoinvoicecon',
    name: 'CreatesoInvoicecon',
    component: CreatesoInvoicecon
  },
  {
    path: '/sinvoice/createrentalinvoice',
    name: 'CreaterentalInvoice',
    component: CreaterentalInvoice
  },
  {
    path: '/rental/createrentalinvoice',
    name: 'RentalCreaterentalInvoice',
    component: CreaterentalInvoice
  },
  {
    path: '/ssalesorder/indexcon',
    name: 'SsalesoderIndexcon',
    component: SsalesoderIndexcon
  },
  {
    path: '/ssalesorder/index',
    name: 'SsalesoderIndex',
    component: SsalesoderIndex
  },
  {
    path: '/ssalesorder/view',
    name: 'SsalesoderView',
    component: SsalesoderView
  },
  {
    path: '/ssalesorder/viewcon',
    name: 'SsalesoderViewcon',
    component: SsalesoderViewcon
  },
  {
    path: '/ssalesorder/update',
    name: 'SsalesoderUpdate',
    component: SsalesoderUpdate
  },
  {
    path: '/ssalesorder/create',
    name: 'SsalesoderCreate',
    component: SsalesoderCreate
  },
  {
    path: '/mproduct/index',
    name: 'MproductIndex',
    component: MproductIndex
  },
  {
    path: '/quotation/index',
    name: 'SquatationIndex',
    component: SquatationIndex
  },
  {
    path: '/quotation/pos',
    name: 'SquatationPos',
    component: SquatationPos
  },
  {
    path: '/quotation/printpos',
    name: 'SquatationPrint',
    component: SquatationPrint
  },
  {
    path: '/quotation/view',
    name: 'SquatationView',
    component: SquatationView
  },
  {
    path: '/quotation/update',
    name: 'SquotationUpdate',
    component: SquotationUpdate
  },
  {
    path: '/quotation/create',
    name: 'SquatationCreate',
    component: SquatationCreate
  },
  {
    path: '/mproduct/update',
    name: 'MproductUpdate',
    component: MproductUpdate
  },
  {
    path: '/mproduct/view',
    name: 'MproductView',
    component: MproductView
  },

  {
    path: '/mcustomer/index',
    name: 'McustomerIndex',
    component: McustomerIndex
  },
  {
    path: '/mcustomer/update',
    name: 'McustomerUpdate',
    component: McustomerUpdate
  },
  {
    path: '/mcustomer/view',
    name: 'McustomerView',
    component: McustomerView
  },
  {
    path: '/mcustomer/create',
    name: 'McustomerCreate',
    component: McustomerCreate
  },
  {
    path: '/sservicejob/scheduleservice',
    name: 'ScheduleService',
    component: ScheduleService
  },
  {
    path: '/login',
    name: 'LoginView',
    component: LoginView
  },
  {
    path: '/igrn/create',
    name: 'GrnCreate',
    component: GrnCreate
  },
  {
    path: '/igrn/index',
    name: 'GrnIndex',
    component: GrnIndex
  },

  {
    path: '/igrn/view',
    name: 'GrnView',
    component: GrnView
  },
  {
    path: '/igrn/update',
    name: 'GrnUpdate',
    component: GrnUpdate
  },
  {
    path: '/igrn/indexreturn',
    name: 'GrnIndexreturn',
    component: GrnIndexreturn
  },
  {
    path: '/igrn/updatedetail',
    name: 'GrnUpdatedetail',
    component: GrnUpdatedetail
  },
  {
    path: '/igrn/createreturn',
    name: 'GrnCreatereturn',
    component: GrnCreatereturn
  },
  {
    path: '/gin/create',
    name: 'GinCreate',
    component: GinCreate
  },
  {
    path: '/gin/createadjust',
    name: 'Createadjust',
    component: Createadjust
  },
  {
    path: '/gin/index',
    name: 'GinIndex',
    component: GinIndex
  },
  {
    path: '/gin/indexcon',
    name: 'GinIndexcon',
    component: GinIndexcon
  },
  {
    path: '/gin/indexadjust',
    name: 'GinIndexadjust',
    component: GinIndexadjust
  },
  {
    path: '/gin/createsogin',
    name: 'CreatesoGin',
    component: CreatesoGin
  },
  {
    path: '/gin/view',
    name: 'GinView',
    component: GinView
  },
  {
    path: '/gin/viewadjust',
    name: 'GinViewadjust',
    component: GinViewadjust
  },
  {
    path: '/gin/viewcon',
    name: 'GinViewcon',
    component: GinViewcon
  },
  {
    path: '/gin/update',
    name: 'GinUpdate',
    component: GinUpdate
  },
  {
    path: '/gin/updatedetail',
    name: 'GinUpdatedetail',
    component: GinUpdatedetail
  },
  {
    path: '/aparment/index',
    name: 'ApartmentIndex',
    component: ApartmentIndex
  },
  {
    path: '/aparment/view',
    name: 'ApartmentView',
    component: ApartmentView
  },
  {
    path: '/aparment/test',
    name: 'ApartmentTest',
    component: ApartmentTest
  },
  {
    path: '/aparment/update',
    name: 'ApartmentUpdate',
    component: ApartmentUpdate
  },
  {
    path: '/contact/update',
    name: 'ContactUpdate',
    component: ContactUpdate
  },
  {
    path: '/tenant/update',
    name: 'TenantUpdate',
    component: TenantUpdate
  },
  {
    path: '/occupant/update',
    name: 'OccupantUpdate',
    component: OccupantUpdate
  },
  {
    path: '/inventory/index',
    name: 'InventoryIndex',
    component: InventoryIndex
  },
  {
    path: '/inventory/indexbyproduct',
    name: 'indexbyProduct',
    component: indexbyProduct
  },
  {
    path: '/issuetracking/index',
    name: 'IssuetrackingIndex',
    component: IssuetrackingIndex
  },
  {
    path: '/issuetracking/create',
    name: 'IssuetrackingCreate',
    component: IssuetrackingCreate
  },
  {
    path: '/issuetracking/createsplit',
    name: 'IssuetrackingCreatesplit',
    component: IssuetrackingCreatesplit
  },
  {
    path: '/issuetracking/view',
    name: 'IssuetrackingView',
    component: IssuetrackingView
  },
  {
    path: '/crm/index',
    name: 'CrmIndex',
    component: CrmIndex
  },
  {
    path: '/crm/create',
    name: 'CrmCreate',
    component: CrmCreate
  },
  {
    path: '/crm/view',
    name: 'CrmView',
    component: CrmView
  },
  {
    path: '/crm/update',
    name: 'CrmUpdate',
    component: CrmUpdate
  },
  {
    path: '/maintenance/index',
    name: 'MaintenanceIndex',
    component: MaintenanceIndex
  },
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },



    ]
  },
  { path: '*', component: NotFound },

];








/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
